import FileInput from '../../../FileInput';
import { useTypeHeaderIcon } from '../../../../utils/hooks/useTypeHeaderIcon';
import { useAuth } from '../../../../utils/Auth';
import { saveDescriptionData } from '../../../../utils/QRFunctions/qrActions';
import { useFileUpload } from '../../../../utils/hooks/useFileUpload';
import FilesList from '../../../FilesList';
import styles from './Asset.module.css';

const Asset = (props) => {
    const { reference } = props;
    const { qr_data, dataDispatch } = useAuth();
    const { header } = useTypeHeaderIcon(qr_data?.data?.qr_type);

    const acceptableFileTypes = ['image/png', 'image/webp', 'image/gif', 'image/jpeg', 'image/jpg', 'application/pdf'];

    const fileHelpers = useFileUpload({ acceptableFileTypes, type: 'asset', fileHandleType: 'qr_files' });
    const { handleFileSelected, filesToDisplay, error } = fileHelpers;

    const handleDescription = (e) => {
        const newDescription = e.target.value;
        dataDispatch({type: 'asset', data: { description: newDescription }});

        const finalQrData = {
            key: 'asset',
            data: {
                ...qr_data?.data?.asset,
                description: newDescription
            }
        };

        if (reference !== 'new' && (qr_data?.id.includes('-') && qr_data?.data.created_at)) {
            saveDescriptionData(qr_data?.id, finalQrData, qr_data);
        };
    };

    return (
        <div className={styles.container}>
            <div className={styles.inputGroupTextArea}>
                <div className={styles.fade} />
                <textarea id='asset-textarea-label' className={styles.textArea} value={qr_data?.data?.asset?.description} onChange={handleDescription}></textarea>
                <label htmlFor='asset-textarea-label' className={qr_data?.data?.asset?.description ? styles.labelFilled : styles.labelTextArea} style={{marginRight: '.5rem'}}>Description</label>
            </div>
            <div className={styles.header} >{header} Files</div>
            <div className={styles.fileContainer}>
                <FilesList filesToDisplay={filesToDisplay} fileHelpers={fileHelpers} />
                <div>Upload File(s)</div>
                {error && <div className={styles.error}>{error}</div>}
                <FileInput
                    onFileSelect={handleFileSelected}
                    acceptedFileTypes={'.gif, .jpg, .jpeg, .pdf, .png, .webp'}
                    multiple={true}
                    label={'Upload'}
                    id={'asset-file-input'}
                    name={'assetFile'}
                    disabled={qr_data?.data?.asset?.files?.length > 4}
                />
            </div>
        </div>
    );
};

export default Asset;
